module.exports = __webpack_public_path__ + "media/images/btn-menu-63f000c8f4587b3d55a27ccea8b63ca4.svg";